import React from 'react'
import { Link } from 'react-router-dom'
import { FaFacebookF, FaInstagram, FaWhatsapp, FaPhone, FaEnvelope, FaMapMarkerAlt, FaTiktok } from 'react-icons/fa'
import { getSettings } from '../../services/api'

const navLinks = [
  { label: 'Inicio', href: '/' },
  { label: 'Servicios', href: '/reservar/servicios' },
  { label: 'Reservar cita', href: '/reservar/servicios' },
]

const serviceLinks = [
  { label: 'Psicoterapia', href: '/reservar/servicios?categoria=PSICOTERAPIA' },
  { label: 'Terapia Ocupacional', href: '/reservar/servicios?categoria=TERAPIA%20OCUPACIONAL' },
  { label: 'Psicopedagogía', href: '/reservar/servicios?categoria=PSICOPEDAGOG%C3%8DA' },
]

const Footer = () => {
  const year = new Date().getFullYear()
  const [logoUrl, setLogoUrl] = React.useState('/images/logo-crema.png')
  const [siteDescription, setSiteDescription] = React.useState('Centro especializado en salud mental y bienestar integral. Brindamos atención profesional y personalizada.')

  const [contactData, setContactData] = React.useState({
    phone: '+56 9 3292 1831',
    email: 'integramentehwh@gmail.com',
    address: 'Concepción, Chile',
    instagram: 'https://www.instagram.com/integramente_hwh/',
    facebook: 'https://www.facebook.com/people/Integramente-HwH/61553813519623/',
    whatsapp: 'https://wa.me/56932921831',
    tiktok: ''
  })

  React.useEffect(() => {
    getSettings().then(res => {
      const d = res.data || {}
      if (d.site_logo) setLogoUrl(d.site_logo)
      if (d.site_description) setSiteDescription(d.site_description)

      setContactData(prev => ({
        ...prev,
        phone: d.contact_phone || prev.phone,
        email: d.contact_email || prev.email,
        address: d.contact_address || prev.address,
        instagram: d.social_instagram ? `https://instagram.com/${d.social_instagram.replace('@', '')}` : prev.instagram,
        facebook: d.social_facebook ? (d.social_facebook.startsWith('http') ? d.social_facebook : `https://facebook.com/${d.social_facebook}`) : prev.facebook,
        tiktok: d.social_tiktok ? `https://tiktok.com/${d.social_tiktok.replace('@', '')}` : prev.tiktok,
        whatsapp: d.contact_whatsapp ? `https://wa.me/${d.contact_whatsapp.replace(/\D/g, '')}` : prev.whatsapp
      }))
    }).catch(console.error)
  }, [])

  const contactInfo = [
    {
      icon: FaPhone,
      value: contactData.phone,
      href: `tel:${contactData.phone.replace(/\s+/g, '')}`
    },
    {
      icon: FaEnvelope,
      value: contactData.email,
      href: `mailto:${contactData.email}`
    },
    {
      icon: FaMapMarkerAlt,
      value: contactData.address,
      href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(contactData.address)}`,
      target: '_blank',
      rel: 'noopener noreferrer'
    },
  ]

  const socialLinks = [
    {
      icon: FaFacebookF,
      href: contactData.facebook,
      label: 'Facebook',
      show: !!contactData.facebook
    },
    {
      icon: FaInstagram,
      href: contactData.instagram,
      label: 'Instagram',
      show: !!contactData.instagram
    },
    {
      icon: FaTiktok,
      href: contactData.tiktok,
      label: 'TikTok',
      show: !!contactData.tiktok
    },
    {
      icon: FaWhatsapp,
      href: contactData.whatsapp,
      label: 'WhatsApp',
      show: !!contactData.whatsapp
    },
  ].filter(link => link.show)

  return (
    <footer className="border-t border-neutral-200 bg-neutral-50/80">
      <div className="mx-auto flex max-w-7xl flex-col gap-10 px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="space-y-4">
            <Link to="/" className="inline-flex items-center gap-3">
              <img src={logoUrl} alt="IntegraMente HwH" className="h-9 w-auto" />
              <span className="text-lg font-bold tracking-tight text-slate-700">
                IntegraMente<span className="text-blue-600">HwH</span>
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-neutral-600">
              {siteDescription}
            </p>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wide text-neutral-500">Navegación</h3>
            <ul className="mt-4 space-y-2 text-sm text-neutral-600">
              {navLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="inline-flex items-center gap-2 transition hover:text-primary-600"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wide text-neutral-500">Servicios</h3>
            <ul className="mt-4 space-y-2 text-sm text-neutral-600">
              {serviceLinks.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="transition hover:text-primary-600">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-semibold uppercase tracking-wide text-neutral-500">Contacto</h3>
            <div className="mt-4 space-y-3 text-sm text-neutral-600">
              {contactInfo.map(({ icon: Icon, value, href, target, rel }) => (
                <a
                  key={value}
                  href={href}
                  target={target}
                  rel={rel}
                  className="flex items-center gap-3 transition hover:text-primary-600"
                >
                  <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-primary-50 text-primary-600">
                    <Icon className="h-4 w-4" />
                  </span>
                  <span>{value}</span>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4 border-t border-neutral-200 pt-6 text-sm text-neutral-500 sm:flex-row sm:items-center sm:justify-between">
          <div className="space-y-2">
            <p className="text-neutral-600">© {year} IntegraMente HWH. Todos los derechos reservados.</p>
            <div className="flex flex-wrap items-center gap-3 text-xs font-medium">
              <Link to="/politica-de-privacidad" className="transition hover:text-primary-600">
                Política de Privacidad
              </Link>
              <span className="text-neutral-300">|</span>
              <Link to="/terminos-y-condiciones" className="transition hover:text-primary-600">
                Términos y Condiciones
              </Link>
            </div>
          </div>

          <div className="flex items-center gap-3">
            {socialLinks.map(({ icon: Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-neutral-200 bg-white text-primary-600 transition hover:border-primary-200 hover:bg-primary-50"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
